var map = {
	"./DD.png": "eb84",
	"./GS75.png": "48fd",
	"./LD.png": "a8eb",
	"./V3.png": "a59d",
	"./V4.png": "277b",
	"./V5.png": "432f",
	"./V64.png": "b774",
	"./V65.png": "8f37",
	"./V75.png": "4834",
	"./V86.png": "894e",
	"./horses-1280_852.jpg": "8d55",
	"./horses-640_426.jpg": "7d42",
	"./hpt.gif": "dd82",
	"./logo.png": "cf05",
	"./logo.svg": "9b19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";